import React, {forwardRef} from 'react';
import styled from 'styled-components';

import {
  directHoverSelector,
  hoverSelector,
} from '../../../../../libs/shared/core/src/helpers/browser/hoverHelpers';
import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  ChromelessButton,
  ChromelessButtonProps,
} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface WorkspaceLineMoreButtonProps extends Partial<ChromelessButtonProps> {
  isMoreOpen: boolean;
}

/*
 * Style.
 */

const StyledMoreButton = styled(ChromelessButton)`
  display: none;
  transform: rotate(90deg);
  border-radius: 4px;
  background-color: ${(p) => p.theme.alphas.transparent};

  ${hoverSelector} {
    display: block;
  }

  ${directHoverSelector} {
    display: block;
    background-color: ${(p) => p.theme.leftBar.itemMoreIconBackgroundHover};
  }
`;

/*
 * Component.
 */

export const WorkspaceLineMoreButton = forwardRef<HTMLDivElement, WorkspaceLineMoreButtonProps>(
  ({isMoreOpen, ...buttonProps}, ref) => {
    const theme = useUserTheme();

    return (
      <TooltipCoordinator render={() => <Trans id="show-actions-copy">Show actions</Trans>}>
        <StyledMoreButton
          ref={ref}
          hasHover={isMoreOpen}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...buttonProps}
        >
          <Icon
            name="more"
            color={theme.leftBar.itemMoreIcon}
            hoverColor={theme.leftBar.itemMoreIconHover}
            hasHover={isMoreOpen}
          />
        </StyledMoreButton>
      </TooltipCoordinator>
    );
  },
);
